"use strict";
var r, e;
function u() {
  return e || (e = 1, r = TypeError), r;
}
export {
  u as __require
};
//# sourceMappingURL=index.es103.js.map
